const SKIP_MODAL_HISTORY_CLEANUP_KEY = '__skipModalHistoryCleanupOnce';

function getWindowSafe(): (Window & typeof globalThis) | null {
  if (typeof window === 'undefined') return null;
  return window;
}

export function skipNextModalHistoryCleanup() {
  const w = getWindowSafe();
  if (!w) return;
  (w as any)[SKIP_MODAL_HISTORY_CLEANUP_KEY] = true;
}

export function consumeSkipNextModalHistoryCleanup(): boolean {
  const w = getWindowSafe();
  if (!w) return false;
  const shouldSkip = Boolean((w as any)[SKIP_MODAL_HISTORY_CLEANUP_KEY]);
  if (shouldSkip) {
    (w as any)[SKIP_MODAL_HISTORY_CLEANUP_KEY] = false;
  }
  return shouldSkip;
}
